import { render, staticRenderFns } from "./ConstructionPriceCalculator.vue?vue&type=template&id=540a12b7"
import script from "./ConstructionPriceCalculator.vue?vue&type=script&lang=ts"
export * from "./ConstructionPriceCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports